// extracted by mini-css-extract-plugin
export default {"container":"LoginLeftSide_container__TKI7R","ssoContainer":"LoginLeftSide_ssoContainer__4gt4h"};